var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-absolute h-100 w-100 pb-5",attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"exclude":"*"}},[_c('router-view')],1),_c('cookie-consent'),_c('LoadingOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }